<template>
  <div class="purchased">
    <div class="icpdemandLoading" v-show="loading" v-loading="true"></div>
    <div class="purchasedTabs">
      <el-tabs v-model="activeName" type="card" @tab-click="handleTabsClick">
        <el-tab-pane label="等待我处理" name="dqr"></el-tab-pane>
        <el-tab-pane label="服务单作废" name="yzf"></el-tab-pane>
        <el-tab-pane label="服务单完成" name="ywc"></el-tab-pane>
        <el-tab-pane label="全部服务单" name="author"></el-tab-pane>
      </el-tabs>
    </div>
    <!-- <div class="purchasedSearch">
      <div class="purchasedSearch-form">
        <span class="purchasedSearch-form-name">服务单号：</span>
        <el-input
          v-model="serviceNumber"
          placeholder="请输入服务单号"
        ></el-input>
      </div>
      <div class="purchasedSearch-form">
        <span class="purchasedSearch-form-name">创建时间：</span>
        <el-date-picker
          v-model="createTimer"
          type="datetime"
          placeholder="选择日期时间"
        >
        </el-date-picker>
      </div>
      <div class="purchasedSearch-form">
        <span class="purchasedSearch-form-name">服务单状态：</span>
        <el-select v-model="serviceType" placeholder="请选择服务单状态">
          <el-option
            v-for="item in serviceTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="purchasedSearch-button">
        <button class="searchList">查询</button>
        <button class="resetList">重置</button>
      </div>
    </div> -->
    <div class="purchasedMain">
      <el-table :data="tableDataList" style="width: 100%;" height="300">
        <el-table-column prop="orderCode" label="服务/需求单号" width="200">
        </el-table-column>
        <el-table-column prop="solutionNo" label="方案编号" width="200">
        </el-table-column>
        <el-table-column prop="companyName" label="企业名称" width="150">
        </el-table-column>
        <!-- <el-table-column prop="orderName" label="联系人"> </el-table-column> -->
        <el-table-column prop="typeName" label="服务类型" width="100">
        </el-table-column>
        <el-table-column prop="orderStatus" label="服务单状态" width="150">
          <template slot-scope="scope">
            <div class="orderStatus">
              <i></i>
              <p>
                <span>{{
                  icpSolutionStatusReference[scope.row.orderStatus]
                    ? icpSolutionStatusReference[scope.row.orderStatus]
                    : '-'
                }}</span>
                <!-- <span>待上传资料</span> -->
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="提交时间" width="200">
        </el-table-column>
        <!-- <el-table-column prop="createTime" label="注册账号"> </el-table-column> -->
        <el-table-column label="操作" width="140">
          <template slot-scope="scope">
            <el-button
              @click="handleTableClick(scope.row)"
              type="text"
              size="small"
              >查看</el-button
            >
            <el-button
              @click="handleGofill(scope.row)"
              type="text"
              size="small"
              v-if="scope.row.actionIndex <= 2"
              >上传材料</el-button
            >
            <el-button
              @click="handleGoFillDetail(scope.row)"
              type="text"
              size="small"
              v-if="scope.row.actionIndex > 2 && scope.row.actionIndex < 4"
              >材料详情</el-button
            >
            <el-button
              @click="handleChangeType(scope.row)"
              type="text"
              size="small"
              v-if="scope.row.actionIndex > 4 && scope.row.actionIndex < 8"
              >变更状态</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableData.length"
        background
      >
      </el-pagination>
    </div>
    <el-dialog title="修改服务状态" :visible.sync="dialogVisible" width="700px">
      <changeFile @tolkParent="tolkParent" :BizId="BizId" />
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { getProgrammeListByUser } from '@/api/alicp.js';
import changeFile from './component/changeFile';
export default {
  components: {
    changeFile,
  },
  computed: {
    ...mapState({
      tabsIndex: (state) => state.alfillmaterials.tabsIndex,
    }),
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      BizId: '',
      serviceNumber: '',
      createTimer: '',
      serviceType: '',
      serviceTypeList: [
        {
          value: '1',
          label: '等待我处理-上传材料',
        },
        {
          value: '2',
          label: '等待客户处理-确认材料',
        },
        {
          value: '3',
          label: '等待我处理-提交工信部',
        },
        {
          value: '4',
          label: '工信部受理中-已注册',
        },
        {
          value: '5',
          label: '工信部受理中-已提交',
        },
        {
          value: '6',
          label: '工信部受理中-已受理',
        },
        {
          value: '7',
          label: '工信部受理中-不予受理',
        },
        {
          value: '8',
          label: '工信部受理中-通过',
        },
        {
          value: '9',
          label: '工信部受理中-未通过',
        },
        {
          value: '10',
          label: '等待客户处理-下载打印邮寄',
        },
        {
          value: '11',
          label: '服务单完成',
        },
      ],
      activeName: 'author',
      tableData: [],
      tableDataList: [],
      currentPage: 1,
      pageSize: 10,
      icpSolutionStatusReference: {
        SOLUTION_SUBMIT: '提交服务单',
        UN_PAID: '未支付',
        PAID: '用户支付',
        //0
        USER_UPLOADED: '基本材料已上传',
        //1
        MATERIAL_UNCONFIRM: '收集并上传材料',
        //2
        USER_CONFIRMED: '客户确认材料',
        //3
        MATERIAL_SUBMITTED: '提交工信部系统',
        //4
        GXB_ACCEPT: '工信部已受理',
        GXB_REFUSE: '工信部不予受理',
        GXB_FAIL: '工信部未通过',
        //5
        GXB_SUCCESS: '工信部通过',
        //6
        ACCOUNT_REGISTERED: '完成账户注册',
        CLOSE: '方案关闭',
        //7
      },
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    //tolkParent
    tolkParent(params) {
      this.loading = params.loading;
      this.dialogVisible = params.dialog;
      this.getTableData();
    },
    //timer
    timer(time) {
      var d = new Date(time);
      var year = d.getFullYear(); //年
      var month = d.getMonth() + 1; //月
      var day = d.getDate(); //日
      var hh = d.getHours(); //时
      var mm = d.getMinutes(); //分
      var ss = d.getSeconds(); //秒
      var clock = year + '/';
      if (month < 10) clock += '0';
      clock += month + '/';
      if (day < 10) clock += '0';
      clock += day + ' ';
      if (hh < 10) clock += '0';
      clock += hh + ':';
      if (mm < 10) clock += '0';
      clock += mm + ':';
      if (ss < 10) clock += '0';
      clock += ss;
      return clock;
    },
    //获取方案列表
    getTableData() {
      this.loading = true;
      let activeName = this.activeName == 'author' ? '' : this.activeName;
      getProgrammeListByUser(activeName).then((res) => {
        this.loading = false;
        this.tableData = [];
        if (res.status == 0) {
          // console.log(res.data);
          res.data.forEach((item) => {
            this.tableData.push({
              orderCode: item.needNo, //服务/需求单号
              solutionNo: item.solutionNo, //方案编号
              companyName: item.solutionContent.solution.CompanyName, //企业 名称
              typeName: item.solutionContent.typeName, //服务类型
              createTime: this.timer(item.created_at), //递交时间
              orderStatus: item.solutionContent.status, //服务单状态
              actionIndex: this.changeActivedIndex(item.solutionContent.status),
              channelSolutionNo: item.channelSolutionNo,
              channelNeedNo: item.channelNeedNo,
            });
          });
          this.handleCurrentChange(1);
        }
      });
    },
    //分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      let list = JSON.parse(JSON.stringify(this.tableData));
      this.tableDataList = list.splice(
        (this.currentPage - 1) * this.pageSize,
        this.pageSize
      );
    },
    //切换tabs状态
    handleTabsClick(tab, event) {
      // console.log(tab, event);
      this.$store.commit('alfillmaterials/changeTabsIndex', tab.name);
      this.getTableData();
    },
    //获取状态值
    changeActivedIndex(type) {
      let activedIndex = null;
      switch (type) {
        case 'SOLUTION_SUBMIT':
          activedIndex = 0;
          break;
        case 'UN_PAID':
          activedIndex = 0;
          break;
        case 'PAID':
          activedIndex = 0;
          break;
        case 'USER_UPLOADED':
          activedIndex = 1;
          break;
        case 'MATERIAL_UNCONFIRM':
          activedIndex = 2;
          break;
        case 'USER_CONFIRMED':
          activedIndex = 3;
          break;
        case 'MATERIAL_SUBMITTED':
          activedIndex = 4;
          break;
        case 'GXB_ACCEPT':
          activedIndex = 5;
          break;
        case 'GXB_REFUSE':
          activedIndex = 5;
          break;
        case 'GXB_FAIL':
          activedIndex = 5;
          break;
        case 'GXB_SUCCESS':
          activedIndex = 6;
          break;
        case 'ACCOUNT_REGISTERED':
          activedIndex = 7;
          break;
        case 'CLOSE':
          activedIndex = 7;
          break;
        default:
          activedIndex = 8;
          break;
      }
      return activedIndex;
    },
    //
    handleTableClick(row) {
      this.$router.push({
        path: '/icporderdetail',
        query: {
          solutionNo: row.solutionNo,
          needNo: row.orderCode,
          BizId: row.channelSolutionNo,
        },
      });
    },
    //
    handleGoFillDetail(row) {
      this.$router.push({
        path: '/icpmaterialdetails',
        query: {
          solutionNo: row.solutionNo,
          needNo: row.orderCode,
          BizId: row.channelSolutionNo,
        },
      });
    },
    //
    handleGofill(row) {
      this.$router.push({
        path: '/alicpfillmaterials/applicantinfo',
        query: {
          BizId: row.channelSolutionNo,
          url: '/icpmyorder/purchased',
          query: JSON.stringify(this.$route.query),
        },
      });
    },
    //改变订单状态
    handleChangeType(row) {
      this.dialogVisible = true;
      this.BizId = row.channelSolutionNo;
    },
  },
};
</script>

<style lang="scss">
.purchased {
  width: 100%;
  height: 100%;
  padding: 30px 30px;
  display: flex;
  flex-direction: column;
  .icpdemandLoading {
    width: 100%;
    height: 100%;
    position: fixed !important;
    top: 0;
    left: 0;
    z-index: 9999;
  }
  .purchasedTabs {
    .el-tabs__item {
      padding: 10px !important;
      width: auto;
      height: auto;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(86, 86, 86, 1);
      line-height: 20px;
      background: #fafafa;
      border-bottom: 1px solid #e4e7ed;
    }
    .is-active {
      color: #ff6a00;
      background: #fff;
    }
  }
  .purchasedSearch {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    padding: 10px 0;
    .purchasedSearch-form {
      // width: 260px;
      display: flex;
      align-items: center;
      margin-right: 40px;
      span {
        display: flex;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        line-height: 22px;
      }
      .el-input {
        width: 200px;
        height: 36px;
        input {
          width: 100%;
          height: 100%;
          border-radius: 4px;
          border: 1px solid rgba(0, 0, 0, 0.15);
        }
      }
    }
    .purchasedSearch-button {
      flex: 1;
      display: flex;
      button {
        cursor: pointer;
        border: none;
        padding: 7px 20px;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 22px;
        border-radius: 4px;
      }
      .searchList {
        margin-right: 10px;
        background: rgba(255, 138, 1, 1);
        color: #fff;
      }
      .resetList {
        background: #fff;
        border: 1px solid rgba(255, 138, 1, 1);
        color: #ff6a00;
      }
    }
  }
  .purchasedMain {
    width: 100%;
    flex: 1;
    margin-top: 20px;
    overflow: auto;
    .el-table__header {
      .has-gutter {
        th {
          height: 54px;
          background: #fafafa;
          border-bottom: 1px solid #e8e8e8;
          .cell {
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.85);
            line-height: 22px;
          }
        }
        th:nth-child(1) {
          padding-left: 15px;
        }
      }
    }
    .el-table__body {
      .el-table__row {
        td {
          height: 54px;
          background: #fff;
          border-bottom: 1px solid #e8e8e8;
          .cell {
            font-size: 13px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(89, 89, 89, 1);
            line-height: 22px;
          }
        }
        td:nth-child(1) {
          padding-left: 15px;
        }
      }
      .el-button--text {
        color: #ff6a00;
      }
    }
    .el-table__body-wrapper {
      height: calc(100% - 54px) !important;
    }
    .el-table--fit {
      height: 100% !important;
    }
    /*修改滚动条样式*/
    .el-table__body-wrapper::-webkit-scrollbar {
      width: 10px;
      height: 10px;
      /**/
    }
    .el-table__body-wrapper::-webkit-scrollbar-track {
      background: rgb(239, 239, 239);
      border-radius: 5px;
    }
    .el-table__body-wrapper::-webkit-scrollbar-thumb {
      background: #bfbfbf;
      border-radius: 10px;
    }
    .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
      background: #a8a8a8;
    }
    .el-table__body-wrapper::-webkit-scrollbar-corner {
      background: #179a16;
    }
    .orderStatus {
      width: 100%;
      display: flex;
      align-items: center;
      i {
        display: flex;
        width: 5px;
        height: 5px;
        border: 1px solid #ff6a00;
        border-radius: 50%;
        margin-right: 14px;
        background: rgba(247, 72, 0, 1);
      }
      p {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        line-height: 18px;
        span {
          display: block;
        }
        span:nth-child(2) {
          color: #bbb;
        }
      }
    }
  }
  .pagination {
    width: 100%;
    margin-top: 40px;
    display: flex;
    justify-content: flex-end;
    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background: #ff6a00;
    }
    .el-pagination.is-background .el-pager li:not(.disabled):hover {
      color: #ff6a00;
    }
    .el-pagination.is-background .el-pager .active:not(.disabled):hover {
      color: #fff;
    }
    .el-select .el-input.is-focus .el-input__inner {
      border-color: #ff6a00;
    }
    .el-pagination__sizes .el-input .el-input__inner:hover {
      border-color: #ff6a00;
    }
    .el-select .el-input__inner:focus {
      border-color: #ff6a00;
    }
  }
}
.el-select-dropdown__item.selected {
  color: #ff6a00;
}
</style>
